// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class AnnouncementStatus {
  
    public static readonly ACTIVE: string = 'Active';
    public static readonly UPCOMING: string = 'Upcoming';
    public static readonly SHOWN: string = 'Shown';
}
